export const LOCAL_STORAGE_AUTH_TOKEN_KEY = "auth_token";

export const getAuthToken = (): string | null => {
  return localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN_KEY);
};